<ng-container *ngIf="action$ | async as action">
  <p-button
    icon="pi pi-hidden"
    [ngClass]="action.name"
    [label]="action.description"
    ntapDebounceClick
    (onClick)="executeAction($event)"
    [disabled]="(isDisabled$ | async) ?? true"
    [pTooltip]="action.tooltip ?? ''"
    tooltipPosition="left"
  ></p-button>
</ng-container>


<p-dialog
  *ngIf="showDialog"
  [resizable]="false"
  [(visible)]="showDialog"
  [modal]="true"
  [draggable]="false"
  appendTo="body"
>
  <ng-template pTemplate="header">
    <h3>Odbijanje verifikacije</h3>
  </ng-template>

  <div class="field md:flex gap-2 align-items-center" [formGroup]="razlogFg">
    <label for="razlog" class="property-label">Razlog odbijanja *</label>

    <textarea rows="6" cols="60" pInputTextarea formControlName="razlog" [autoResize]="true"></textarea>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex">
      <p-button (onClick)="closeDialog()">Odustani</p-button>
      <p-button (onClick)="confirmRejection()" [disabled]="!this.razlogFg.valid">Potvrdi</p-button>
    </div>
  </ng-template>
</p-dialog>
